import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DocumentRequestDashboardComponent} from "./document-request-dashboard.component";


export const documentrequestDashboard: Routes = [
  {
    path: 'document-request-dashboard',
    component:DocumentRequestDashboardComponent
  }
];


@NgModule({
  imports: [RouterModule.forChild(documentrequestDashboard)],
  exports: [RouterModule]
})
export class DocumentRequestDashboardRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard-routing.module.ts